import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGetOfferCheckList } from '../../hooks/react-query/useAdmin';
import { MapperOfferCheck } from '../../utils/importDriver/mapper';
import Container from '../../components/elements/container';
import { TableSkeletion } from '../../components/elements/skeletions';
import { Table } from '../../components/ui/Table';
import {
  TableBodyComponent,
  TableHeadersComponent,
} from '../../components/admin/table';
import { NoDataFound } from '../../components/elements/noDataFound';
import OfferCheckDetails from '../../components/admin/offersCheck/offerCheckDetails';
import { LeftArrow } from '../../icons';

const OfferCheck = () => {
  const navigate = useNavigate();

  const { data: OfferList, isLoading } = useGetOfferCheckList();

  const [offerTableData, setOfferData] = useState(null);
  const [detailsTableData, setDetailsTableData] = useState(false);

  useEffect(() => {
    setOfferData(MapperOfferCheck(OfferList, 'offerCheck'));
  }, [OfferList]);

  if (isLoading) {
    return (
      <Container className="max-lg:px-0">
        <TableSkeletion />
      </Container>
    );
  }

  if (!OfferList || !offerTableData || (OfferList && !OfferList.data.length)) {
    return (
      <Container className="flex flex-col gap-6 max-lg:px-0">
        <div className="flex max-lg:gap-x-2 items-center">
          <button className='lg:p-2' type="button" onClick={() => navigate('/dashboard')}>
            <LeftArrow width={24} height={24} />
          </button>
          <h2> Offers Check</h2>
        </div>
        <NoDataFound
          className="flex items-center justify-center bg-white p-4"
          title="Δεν υπάρχουν διαθέσιμα δεδομένα στο πίνακα."
        />
      </Container>
    );
  }

  const handleRowClick = (selectedRow) => {
    setDetailsTableData(selectedRow);
  };

  if (detailsTableData) {
    return (
      <OfferCheckDetails
        rowData={detailsTableData}
        handleBackButton={() => setDetailsTableData(null)}
      />
    );
  }

  return (
    <Container className="flex flex-col gap-6 overflow-y-auto max-h-[88vh] max-lg:px-0">
      <div className="flex lg:gap-x-0 gap-x-6 items-center max-lg:px-5">
        <button type="button" className='lg:p-2' onClick={() => navigate('/dashboard')}>
          <LeftArrow width={24} height={24} />
        </button>
        <h1 className="h2"> Offers Check</h1>
      </div>
      <Table wrapperClassName="p-2 lg:p-4 scrollbar overflow-auto max-lg:rounded-none">
        <TableHeadersComponent
          selectedColumns={[]}
          tableData={offerTableData}
        />
        <TableBodyComponent
          tableData={offerTableData}
          selectedColumns={[]}
          handleAction={handleRowClick}
        />
      </Table>
    </Container>
  );
};

export default OfferCheck;
